/* SAP'S STORE — Cart Drawer
   Handles open/close, add-to-cart via fetch, qty updates, and re-rendering.
*/
(function () {
  'use strict';

  const drawer = document.querySelector('[data-cart-drawer]');
  const openBtns = document.querySelectorAll('[data-cart-open]');
  const closeBtns = document.querySelectorAll('[data-cart-close], [data-cart-close-nav]');
  const itemsWrap = document.querySelector('[data-cart-items]');
  const cartCount = document.querySelector('[data-cart-count]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  openBtns.forEach(b => b.addEventListener('click', (e) => { e.preventDefault(); refreshCart(); openDrawer(); }));
  closeBtns.forEach(b => b.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  // Delegate clicks inside items
  if (itemsWrap) {
    itemsWrap.addEventListener('click', (e) => {
      const remove = e.target.closest('[data-cart-remove]');
      if (remove) {
        e.preventDefault();
        updateLine(parseInt(remove.dataset.line, 10), 0);
        return;
      }
      const qtyBtn = e.target.closest('[data-qty-change]');
      if (qtyBtn) {
        e.preventDefault();
        const line = parseInt(qtyBtn.dataset.line, 10);
        const delta = parseInt(qtyBtn.dataset.qtyChange, 10);
        const input = itemsWrap.querySelector(`[data-qty-input][data-line="${line}"]`);
        const current = input ? (parseInt(input.value, 10) || 0) : 0;
        updateLine(line, Math.max(0, current + delta));
      }
    });

    itemsWrap.addEventListener('change', (e) => {
      const input = e.target.closest('[data-qty-input]');
      if (input) {
        const line = parseInt(input.dataset.line, 10);
        const qty = Math.max(0, parseInt(input.value, 10) || 0);
        updateLine(line, qty);
      }
    });
  }

  function updateLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line, quantity })
    }).then(r => r.json()).then(() => refreshCart());
  }

  function refreshCart() {
    fetch('/cart.js').then(r => r.json()).then((cart) => {
      if (cartCount) cartCount.textContent = cart.item_count;
    });
    // Re-render items via section rendering API
    fetch('/?section_id=cart-drawer-items').then(r => r.text()).then((html) => {
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const rendered = tmp.querySelector('[data-cart-items]') || tmp;
      if (itemsWrap && rendered) itemsWrap.innerHTML = rendered.innerHTML;
    }).catch(() => {
      // Fallback: just reload
      if (window.location.pathname.includes('/cart')) window.location.reload();
    });
  }

  // Intercept add-to-cart form
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form && form.id === 'product-form') {
      e.preventDefault();
      const fd = new FormData(form);
      const submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: fd
      }).then(r => r.json()).then(() => {
        refreshCart();
        openDrawer();
        if (submitBtn) submitBtn.disabled = false;
      }).catch((err) => {
        console.error(err);
        if (submitBtn) submitBtn.disabled = false;
        alert('No pudimos añadir el producto. Intenta de nuevo.');
      });
    }
  });
})();
